<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      @success="onSuccess"
      @openAddDialog="handleExport"
      buttonType="warning"
      buttonName="导出"
      addShowPower="/fin/exportMemAccts"
      :submitService="submitService"
      :submitData="submitData"
      :showDownloadPower="true"
      showDownloadPowerType="purple"
      downloadPowerText="合计"
      downloadPower="/statistics/qpayInfoQry"
      @down="down"
    >
      <select-organs v-model="formModel.tatSimpleId"></select-organs>
      <el-form-item label="会员名称">
        <el-input
          maxlength="20"
          type="text"
          v-model="formModel.memName"
          placeholder="请输入会员名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="会员电话">
        <el-input
          maxlength="20"
          type="text"
          v-model="formModel.phoneNumber"
          placeholder="请输入会员电话"
        ></el-input>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="tatSimpleName"
        label="机构简称"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="nickName"
        label="会员名称"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="phoneNumber"
        label="会员电话"
        min-width="130"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="totalSum"
        label="总余额（元）"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableNumber"
      ></el-table-column>
      <el-table-column
        prop="withdrawSum"
        label="可提现余额（元）"
        min-width="150"
        show-overflow-tooltip
        :formatter="formatterTableNumber"
      >
      </el-table-column>
      <el-table-column
        prop="rebateSum"
        label="返利余额（元）"
        min-width="150"
        show-overflow-tooltip
        :formatter="formatterTableNumber"
      >
      </el-table-column>
    </common-table>

    <show-info-dialog
      title="合计"
      :show="true"
      ref="showInfoDialog"
      dialogWidth="400px"
      class="showInfoDialog"
    >
      <div>
        <p>变动金额：{{ toDoubleThousands(dialogAmount) }}元</p>
      </div>
    </show-info-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import SelectOrgans from "components/business/SelectOrgans";
import ShowInfoDialog from "../../dialog/ShowInfoDialog";

import FinanceService from "service/FinanceService";
import StatisticsService from "service/StatisticsService";
import OrganService from "service/OrganService";
import privateKey from "service/constant/privateKey";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "memberaccountdetail",
  components: {
    CommonTopForm,
    CommonTable,
    SelectOrgans,
    ShowInfoDialog,
  },
  data() {
    return {
      dialogAmount: 0,
      formModel: {
        tatSimpleId: "",
        memName: "",
        phoneNumber: "",
      },
      all: [
        {
          id: "",
          simpleName: "全部",
        },
      ],
      dialogTypes: [
        {
          value: "1",
          label: "到机构",
        },
        {
          value: "2",
          label: "到会员",
        },
      ],
      tableData: [{}],
      formDialogTitle: "",
      dialogModel: {
        tatSimpleId: "",
        adjustType: "",
        adjustAmt: "0",
        remark: "",
      },
      dialogRules: {},
      params: {},
      page: {},
      adjustId: "",
      submitService: FinanceService.getMemAccts,
      isPage: false,
    };
  },
  mixins: [loadMixin, dialogMixin],
  mounted() {
    this.page = this.$refs.commonTable.page;
    this.getList();
  },
  computed: {
    submitData() {
      const params = {
        userId: this.userId,
        tatSimpleId: this.formModel.tatSimpleId,
        memName: this.formModel.memName.trim(),
        phoneNumber: this.formModel.phoneNumber.trim(),
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  methods: {
    handleExport() {
      this.limitExport(this.page.total)
        ? StatisticsService.exportExcel(
            this.submitData,
            "exportMemAccts",
            "",
            "/fin/"
          )
        : "";
    },
    down() {
      this.doLoad(
        StatisticsService.statisGetMemAccts,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.dialogAmount = 0;
            if (result) {
              this.dialogAmount = result.totalSum;
            }
            this.$nextTick(() => {
              this.$refs.showInfoDialog.open();
            });
          });
        },
        "信息获取失败"
      );
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        FinanceService.getMemAccts,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.tableData = result.rows;
            this.page.currentPage = result.current;
            this.page.pageSize = result.size;
            this.page.total = result.total;
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(data) {
      this.doCheck(data, (res) => {
        const result = res.contents;
        this.tableData = result.rows;

        this.page.currentPage = result.current;
        this.page.pageSize = result.size;
        this.page.total = result.total;
      });
    },
    updateInfo(id) {
      this.adjustId = id;
      this.formDialogTitle = "调账";
      this.$refs.formDialog.open();
    },
    handleChange() {},
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/FinanceManage/MemberAccountDetail.vue